export default __webpack_public_path__ + "build/0efb90c19a8865eb864ed3489508d339.svg";